function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1-martillo{fill:none;stroke:#f15f67;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.8px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Martillo-02",
  transform: "translate(1.4 1.4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_126",
  d: "M2.58 24.584h16.477L17.7 19.16H3.639z",
  className: "cls-1-martillo",
  "data-name": "Path 126",
  transform: "translate(-2.438 8.498)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_127",
  d: "M10.412 24.584l2.088-3.638 10.057-9.868 2.91-1.55-6.183-6.166-1.676-1.692-1.5 3.289-10.218 10.2-3.4 1.629 2.2 2.151z",
  className: "cls-1-martillo",
  "data-name": "Path 127",
  transform: "translate(-2.49 -1.67)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_128",
  d: "M15.931 10.14l12.335 12.334a3.355 3.355 0 0 1-4.744 4.744L11.14 14.837",
  className: "cls-1-martillo",
  "data-name": "Path 128",
  transform: "translate(2.539 3.254)"
}));

var SvgMartillo02 = function SvgMartillo02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34.587,
    height: 35.882,
    viewBox: "0 0 34.587 35.882",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMartillo02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/martillo-02.1d8d533b.svg";
export { ForwardRef as ReactComponent };